module.exports = __webpack_public_path__ + "img/premium_offers_mobile.207df75d.webp";